export { DialogContentText, DialogContentTextProps } from './DialogContentText';
